import React from "react";
import monaLogo from "../../assets/mona-mascot-temp.png";
import { useTranslation } from "react-i18next";
import { Colors } from "../../constants/Colors";

export const AboutUs = () => {
  const { i18n } = useTranslation();
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          padding: "1rem",
          marginTop: "2rem",
          width: "90%",
          maxWidth: "400px",
          margin: "0 auto",
          fontFamily: "Arial, sans-serif",
          color: "#333",
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
        }}
      >
        {/* Profile Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "1rem",
            borderBottom: "1px solid #ddd",
            paddingBottom: "1rem",
          }}
        >
          <img
            src={monaLogo}
            alt="Mona"
            style={{
              width: "55px",
              borderRadius: "50%",
              marginRight: "1rem",
            }}
          />
          <div>
            <div style={{ fontWeight: "bold", fontSize: "1rem" }}>
              Mona by Netmonk
            </div>
            <div style={{ color: Colors.primary80, fontSize: "0.9rem" }}>
              Version 1.0.0
            </div>
          </div>
        </div>

        {/* Description */}
        <p
          style={{
            fontSize: "0.9rem",
            lineHeight: "1.6",
            textAlign: "justify",
          }}
        >
          {i18n.language === 'id' ?
          "Mona adalah asisten virtual cerdas yang memudahkan pengguna mengakses informasi secara cepat dan interaktif. Ia memungkinkan pemantauan efisien terhadap performa jaringan dan infrastruktur TI serta membantu pengambilan keputusan berbasis data. Dengan antarmuka intuitif, Mona meningkatkan pengalaman pengguna dengan produk Netmonk, menjadikan solusi ini lebih responsif dan terintegrasi dalam operasional harian."
          :
          "Mona is an intelligent virtual assistant that makes it easy for users to access information quickly and interactively. It enables efficient monitoring of network and IT infrastructure performance and assists in data-driven decision-making. With an intuitive interface, Mona enhances the user experience with Netmonk products, making this solution more responsive and integrated into daily operations."
          }
        </p>
      </div>
    </div>
  );
};
